import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "className", "variant", "gutterBottom", "disableResponsiveSizing", "fontStyle", "appearance", "name", "wrap", "color"];
/* Copied from the ConsumerSite Pattern Library temporarily.
 *
 */
import styles from "./typography.module.scss";
import classnames from "classnames";
import * as React from "react";
import { jsx as ___EmotionJSX } from "@emotion/core";
var variantMapping = {
  "default": "span",
  "display-l": "h1",
  "display-m": "h1",
  "display-s": "h2",
  "display-xs": "h2",
  "heading-xl": "h1",
  "heading-l": "h2",
  "heading-m": "h2",
  "heading-s": "h3",
  "heading-xs": "h4",
  "heading-xxs": "h4",
  "heading-xxxs": "h4",
  "body-xl": "p",
  "body-l": "p",
  "body-m": "p",
  "body-s": "p",
  "body-xs": "p",
  inherit: "span",
  body: "p"
};

/** @deprecated - please migrate to using appearance where possible */

// Trick TS to not validate constructed classNames like appearance-XXX and weight-XXX

// Utils
function spacesToSnakeCase(str) {
  return str.replace(/\s+/g, "-").toLowerCase();
}
function buildTestAttribute(appendix, name) {
  var testDataAttribute = {};
  if (name) {
    testDataAttribute["data-".concat(spacesToSnakeCase(name), "-").concat(spacesToSnakeCase(appendix))] = true;
  }
  return testDataAttribute;
}
export var Typography = React.forwardRef(function (_ref, ref) {
  var _classnames;
  var component = _ref.as,
    className = _ref.className,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "default" : _ref$variant,
    _ref$gutterBottom = _ref.gutterBottom,
    gutterBottom = _ref$gutterBottom === void 0 ? false : _ref$gutterBottom,
    _ref$disableResponsiv = _ref.disableResponsiveSizing,
    disableResponsiveSizing = _ref$disableResponsiv === void 0 ? false : _ref$disableResponsiv,
    fontStyle = _ref.fontStyle,
    appearance = _ref.appearance,
    name = _ref.name,
    wrap = _ref.wrap,
    color = _ref.color,
    others = _objectWithoutProperties(_ref, _excluded);
  var Component = component || variantMapping[variant] || "span";
  // Use the weight prop if passed in from a Body variant -
  var weight = "weight" in others ? others.weight : null;
  return ___EmotionJSX(Component, _extends({
    "data-bpl": true,
    className: classnames(styles.typography, styles.prettyStyle, styles[wrap || ""], (_classnames = {}, _defineProperty(_classnames, styles[variant], variant !== "inherit"), _defineProperty(_classnames, styles["appearance-".concat(appearance)], appearance), _defineProperty(_classnames, styles["appearance-default"], !appearance || appearance === "default"), _defineProperty(_classnames, styles["color-".concat(color)], !!color && !appearance), _defineProperty(_classnames, styles.disableResponsiveSizing, disableResponsiveSizing), _defineProperty(_classnames, styles["weight-".concat(weight)], weight), _defineProperty(_classnames, styles["fontstyle-".concat(fontStyle)], fontStyle), _defineProperty(_classnames, styles.gutterBottom, gutterBottom), _classnames), className),
    ref: ref
  }, buildTestAttribute("typography", name), others));
});
// Wrap children in a default Typography component if they are of type string.
export var TypographyStringWrapper = function TypographyStringWrapper(_ref2) {
  var children = _ref2.children,
    _ref2$wrap = _ref2.wrap,
    wrap = _ref2$wrap === void 0 ? "pretty" : _ref2$wrap;
  if (typeof children === "string") {
    return ___EmotionJSX(Typography, {
      wrap: wrap
    }, children);
  }
  return ___EmotionJSX(React.Fragment, null, children);
};
export default Typography;